import React, {useEffect, useRef, useState} from "react";
import {t} from "i18next";

export type MenuItem = {
    label: string;
    action: () => void;
};

interface MenuProps {
    items: MenuItem[];
}

export default function Menu({items}: MenuProps) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    return (
        <div className="account-menu-wrapper" ref={menuRef}>
            <button
                type="button"
                className="form-button-secondary account-menu-trigger"
                onClick={() => setOpen(!open)}
            >
                {t("common.menu")} {open ? "▲" : "▼"}
            </button>

            {open && (
                <div className="account-menu-dropdown">
                    {items.map((item, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setOpen(false);
                                item.action();
                            }}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}